// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography, Backdrop } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import MainGroupLedgerAccount from "./MainGroupLedgerAccount";
// Constants
import { MAIN_GROUP_LEDGER_ACCOUNT_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const MainGroupLedgerAccounts = ({ mainGroupLedger, mainGroupLedgerId, mainGroupLedgerAccounts, reload }) => {
    const permissions = usePermissions();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "asc",
        max: 10,
        offset: 0,
        search: ""
    });

    const [main_group_ledger_accounts, setMainGroupLedgerAccounts] = useState({
        entries: mainGroupLedgerAccounts,
        total_count: 0
    });

    const onClose = () => {
        setOpen(false);
        reload();
    };

    useEffect(() => {
        setMainGroupLedgerAccounts(prevState => ({ ...prevState, entries: mainGroupLedgerAccounts }))
    }, [mainGroupLedgerAccounts]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Accounts
                    </Typography>
                    {permissions.has(PermissionConstants.MAIN_GROUP_LEDGER_CREATE) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => { setId(undefined); setOpen(true) }}
                        >
                            New Account
                        </Button>
                    }
                </Stack>
                <Card>
                    <GoTable
                        search={false}
                        pagination={false}
                        tableHeads={MAIN_GROUP_LEDGER_ACCOUNT_TABLE_HEADS}
                        tableDatas={main_group_ledger_accounts.entries}
                        totalCount={main_group_ledger_accounts.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter(filter)}
                        onView={(row) => { setId(row.id); setOpen(true) }} />
                </Card>
            </Container>
            <Backdrop open={open} />
            {
                permissions.has(PermissionConstants.MAIN_GROUP_LEDGER_VIEW) && open && <GoDrawer
                    // minwidth="50%"
                    title="Invoice Line"
                    open={open}
                    onClose={() => onClose()}
                >
                    <MainGroupLedgerAccount id={id} mainGroupLedger={mainGroupLedger} mainGroupLedgerId={mainGroupLedgerId} onClose={() => onClose()} />
                </GoDrawer>
            }

        </React.Fragment>
    );
}

export default MainGroupLedgerAccounts;